export const translationRu = {
  shared: {
    error: {
      base: 'Произошла ошибка',
      invalidRequest: 'Недопустимое содержание запроса',
      required: 'Обязательное поле',
      email: 'Неправильный email',
      minSixLetter: 'Минимум 6 символов',
      copy: 'Произошла ошибка при копировании',
      data: 'Произошла ошибка при загрузке данных',
      video: 'Ваш браузер не поддерживает видео тег',
      timeSessionExpired: 'Время сессии истекло',
      download: 'Произошла ошибка при загрузке файла',
    },
    message: {
      copy: 'Скопировано',
    },
    text: {
      yes: 'Да',
      no: 'Нет',
      empty: 'Нет данных',
      upTo: 'До',
      checkConnectionAndTryAgain:
        'Проверьте интернет-соединение и попробуйте ещё раз',
      repeat: 'Повторить попытку',
      noData: 'Нет данных',
      continue: 'Продолжить',
      back: 'Назад',
      finish: 'Готово',
      ok: 'Ок',
    },
    plural: {
      days_one: '{{count}} день',
      days_many: '{{count}} дней',
      days_few: '{{count}} дня',
      months_many: '{{count}} месяцев',
      months_one: '{{count}} месяц',
      months_few: '{{count}} месяца',
    },
  },
  installation: {
    finish: "Поздравляем! Вы успешно установили Private Gate VPN!",
  },
  theme: {
    toggle: 'Сменить тему',
  },
  banner: {
    premiumExpiration: {
      title: 'Привет👋',
      subtitle:
        'Ненавязчиво предупреждаем, что ваша Премиум подписка закончится через {{count}} дня.',
      description: 'Продлите сейчас, чтобы не думать об этом дальше 👇',
      button: 'Продлить Премиум',
    },
    premiumExpiration_1: {
      title: 'Привет! ⏳ Завтра истекает срок твоей Premium подписки.',
      subtitle: `Представь, как много ты можешь потерять, вернувшись к бесплатной версии: Текущий VPN на технологии X-Ray, который невозможно заблокировать, перестанет работать.
        
        Продление сейчас гарантирует тебе продолжение безопасного и неограниченного доступа к интернету. Сделай выбор в пользу своей удобности и безопасности.
        `,
      description: 'Продли прямо сейчас, не жди до последнего момента! 👇',
      button: 'Продлить Премиум',
    },
    premiumExpiration_9: {
      title: `Привет 👋 Добро пожаловать
в Private Gate VPN!`,
      subtitle: `Мы дарим тебе {{count}} дней бесплатного триала — без обязательств и без карты. Пользуйся, тестируй и наслаждайся свободным интернетом.

Просто включи и почувствуй разницу. Если всё понравится — переходи на платный план и оставайся защищённым 🚀`,
      description: '',
      button: 'Начать работу',
    },
    premiumExpired: {
      title: `😿 Твой тариф поменялся 
на бесплатный`,
      subtitle: `Если у тебя был установлен VPN через приложение (технология X-Ray), то он перестал работать. Чтобы продолжить пользоваться VPN через приложение нужно вернуться на Премиум.
      
      Для бесплатного доступа тебе нужно установить наш альтернативный VPN протокол без приложений в настройках твоего устройства. Сделать это можно через "Профиль".
      `,
      description:
        'Чтобы вернуться на Премиум тариф и продолжить пользоваться VPN без головной боли, нажми "Купить VPN" 👇',
      button: 'Продлить Премиум',
    },
    freeConnection: {
      title: `Ваш тариф — бесплатный`,
      subtitle: `Для настройки нового подключения, пожалуйста подключите премиум тариф.`,
      button: 'Продлить Премиум',
    },
    premiumExpired_7: {
      title: `Перестал работать VPN?`,
      subtitle: `Это потому, что у тебя бесплатный тариф с ограничением по скорости. Для бесплатного доступа тебе нужно установить наш альтернативный VPN протокол без приложений. Сделать это можно через "Профиль".`,
      description:
        'Чтобы "вернуть все как было" и продолжить пользоваться неограниченного доступом к интернету, продли подписку сейчас 👇',
      button: 'Купить Премиум',
    },
    speedLimit: {
      title: `Перестал 
      работать VPN?`,
      subtitle: `Это потому что у тебя бесплатный тариф с ограничением по скорости. Для бесплатного доступа тебе нужно установить наш альтернативный VPN протокол без приложений. Сделать это можно через "Профиль".`,
      description:
        'Чтобы "вернуть все как было" и продолжить пользоваться неограниченного доступом к интернету, продли подписку сейчас 👇',
      button: 'Купить Премиум',
    },
    successfulPayment: {
      heading: 'Спасибо что выбрали нас! Оплата прошла успешно',
      hint: 'Чтобы вернуться на главную страницу нажмите на кнопку:',
      button: 'На главную страницу',
    },
    failedPayment: {
      heading: 'Что-то пошло не так. Оплата прошла не успешно',
    },
    inProgressPayment: {
      heading: 'Оплата совершается...',
    },
    noXrayPopup: "Протокол X-Ray VPN доступен только на Premium тарифе.\nЧтобы продолжить пользоваться VPN, который невозможно заблокировать, нужно перейти на Premium тариф."
  },
  society: {
    facebook: 'https://www.facebook.com/groups/privategatevpn',
    telegram: 'https://t.me/privategatevpn',
    youtube: 'https://youtube.com/@PrivateGateEN?si=ovsYcKMzX25r-fSE',
  },
  links: {
    offer: 'https://privategatevpn.com/offerru',
    privacyPolicy: 'https://privategatevpn.com/privacypolicyru',
  },
  landing: {
    india: {
      badge: 'Тарифы для Индии',
      title: 'Private Gate VPN',
      titleSubtitle: 'Special for India',
      subtitle:
        'Создайте аккаунт из Индии и после регистрации получите локальные тарифы в INR.',
      benefits: [
        'VPN для сетей с ограничениями',
        'Быстрая настройка на всех устройствах',
        'Локальные тарифы для Индии',
      ],
    },
    russia: {
      badge: '3 ДНЯ БЕСПЛАТНО',
      title: 'Private Gate VPN',
      titleSubtitle: 'VPN для России',
      subtitle:
        'Введите email, подтвердите код — и тестовый доступ придёт прямо на почту.',
      benefits: [
        'Подключение без Telegram на первом шаге',
        '3 дня тестового доступа',
        'После теста можно привязать Telegram и оплатить доступ',
      ],
      success: {
        badge: 'Доступ готов',
        title: 'Ваш VPN готов',
        description:
          'Нажмите «Активировать VPN», выберите устройство и следуйте короткой инструкции.',
        descriptionWithEmail:
          'Доступ готов. Ссылка для настройки также отправлена на {{email}}.',
        activateButton: 'Активировать VPN',
        supportButton: 'Написать в поддержку',
        supportSubject: 'Проблема с VPN',
      },
      returning: {
        title: 'Ваше подключение',
        badge: 'Вход выполнен',
        description: 'Откройте настройку вашего VPN. Срок доступа остался прежним.',
        noConnection: 'Сейчас нет доступного подключения. Продолжить настройку или оплатить доступ можно в Telegram.',
        telegramButton: 'Продолжить в Telegram',
      },
      existingAccount: {
        title: 'Этот email уже зарегистрирован',
        description:
          'Аккаунт с этим email уже существует. Продолжить работу и привязать аккаунт можно через Telegram.',
        telegramButton: 'Открыть Telegram',
        support: 'Если нужна помощь, напишите нам:',
      },
    },
  },
  navigation: {
    faq: 'FAQ',
    howToInstall: 'Как установить',
    usefulLinks: 'Полезные ссылки',
    howItWorks: 'Как это работает',
    enterPromoCode: 'Ввести промокод',
    bringFriend: 'Приведи друга',
    support: 'Поддержка',
    logout: 'Выйти',
  },
  footer: {
    offer: 'Оферта',
    privacyPolicy: 'Политика конфиденциальности',
  },
  howItWorks: {
    howItWorks: {
      title: 'Как это работает',
      action: 'Как установить',
      description: `В Private Gate VPN используется технология X-Ray (VLESS).

Она подходит для регионов с высоким уровнем цензуры. Это новейший VPN протокол, который маскирует ваш трафик в интернете.

✅ Невозможно заблокировать
✅ Работает всегда и везде
✅ Простая и быстрая установка
✅ Стабильный
✅ Работает на любых устройствах

Для работы этого протокола, вам необходимо получить конфигурацию VPN сервера и установить ее в специализированное приложение.
Следуйте подробным инструкциям на этой странице:`,
    },
    gift: {
      title: '14 дней Premium в подарок',
      action: 'Перейти на Premium',
      description: `Мы заботливо дарим всем 14 дней Premium с самого старта.

Если тебя устраивает текущая работа нашего VPN, рекомендуем оплатить сейчас и не думать об этом в самый неподходящий момент. 
Чтобы не ломать голову и продолжать включать VPN одной кнопкой, оплати подписку сейчас: 
`,
    },
    bot: {
      title: 'Наш телеграм бот',
      links: `Запускай бота по ссылке:--https://t.me/PrivateGateVPNbot`,
      description: `Неудобно пользоваться через браузер? У нас есть удобный бот в Telegram, через который также можно получить VPN. 
      
      `,
    },
    chat: {
      title: 'Наш телеграм канал и чат',
      links: `📣 Канал--https://t.me/privategatevpn_ru ||
💬 Чат--https://t.me/privategatevpn_chat_ru `,
      description: `Давай всегда оставаться на связи 🤙

📣 Подпишись на наш Телеграм канал, где мы делимся уникальными предложениями, акциями, новостями и лайфхаками для безопасного использования интернета.

💪 Присоединяйся сейчас и начни получать эксклюзивные предложения и пользу уже сегодня!

Мы ждем тебя💚
`,
    },
    feedback: {
      title: 'Оставить обратную связь',
      links: `👉 Все, что нужно сделать, — это написать нам на почту: support@irs-lab.fr`,
      description: `Если у тебя есть идеи, как мы можем улучшить твое приключение с Private Gate VPN, пожалуйста, поделись ими. 
Мы ценим твое мнение и готовы помочь с любыми вопросами. 

`,
    },
  },
  authentication: {
    notify: {
      successRegister: 'Аккаунт успешно создан',
      userNotFound: 'Пользователь не найден',
    onDisagreeance: 'Вы не можете зарегистрироваться, не согласившись с Офертой и Политикой конфиденциальности'
    },
    login: {
      title: 'Логин',
      noAccountYet: 'Ещё нет аккаунта?',
      register: 'Зарегистрируйтесь',
      error: 'Произшла ошибка',
      password: 'Пароль',
      loginButton: 'Войти',
    },
    registration: {
      title: 'Регистрация',
      agreement: 'Регистрируясь, вы соглашаетесь со следующими документами:',
      and: 'и',
      otp: 'На почту придёт одноразовый пароль для входа',
      offerAgreement: 'Оферта',
      privacyPolicy: 'Политика конфиденциальности',
      alreadyHaveAccount: 'Уже есть аккаунт?',
      login: 'Войти',
      next: 'Далее',
      email: 'Email',
    },
    otp: {
      title: "Введите код подтверждения",
      code: "Проверьте свой почтовый ящик и папку со спамом на наличие проверочного кода, отправленного по адресу:",
      nocode: "Не получили код?",
      resend: "Отправить ещё раз",
      resendSuccess: "Код успешно отправлен",
      next: "Далее",
      wrong: "Неверный или истёкший код",
      provisioningError: "Не удалось настроить VPN. Попробуйте запросить новый код немного позже.",
      serviceError: "Сервис временно недоступен. Попробуйте ещё раз немного позже.",
      wait: "Вы можете отправлять запросы раз в 60 секунд. Подождите ",
      seconds: " секунд для отправки следующего запроса"
    },
  },
  instruction: {
    step: 'Шаг',
    final: 'Финал',
    image: 'Инструкция',
  },
  provider: {
    name: {
      crypto: 'Оплата криптовалютой',
      payze: 'Международные банковские карты (через Payze)',
      ruCloudPayments: 'Российские банковские карты',
      stripe: 'Международные банковские карты (через Stripe)',
    },
  },
  connection: {
    full: 'Невозможно создать новое подключение. Достигнуто максимальное количество соединений. Удалите одно из имеющихся соединений, чтобы создать новое',
    error: {
      create: 'Произошла ошибка при создании подключения',
    },
    actions: 'Действия',
    downloadConfig: 'Скачать VPN конфигурацию',
    whichDevice:
      'На какое устройство вы хотите загрузить файл конфигурации VPN?',
    howToInstall: 'Как установить',
    changeDevice: 'Сменить устройство',
    delete: 'Удалить',
    confirm: {
      changeDevice: 'Уверены, что хотите сменить устройство?',
      delete: 'Уверены, что хотите удалить подключение?',
    },
    notify: {
      successDeleted: 'Подключение успешно удалено',
    },
    list: 'Ваши устройства и подключения',
    add: 'добавить устройство',
    addNewDevice: 'Добавить новое устройство',
    cancelAdding: 'Закрыть',
    name: 'Private Gate',
    server: 'Сервер подключения',
    login: 'Имя пользователя',
    password: 'Пароль',
  },
  country: {
    selectCountry: 'Выберите страну для подключения',
    selectCountryDescription:
      'Страна к которой будет подключено ваше устройство, в дальнейшем сможете сменить:',
    name: {
      empty: '🏳️ Не выбрана',
      kz: '🇰🇿 Казахстан',
      ka: '🇰🇿 Казахстан',
      ge: "🇩🇪 Германия",
      un: "🇦🇪 Арабские Эмираты",
      de: '🇩🇪 Германия',
      us: '🇺🇸 США',
      ru: '🇷🇺 Россия',
      nl: '🇳🇱 Нидерланды',
      sg: '🇸🇬 Сингапур',
      fr: '🇫🇷 Франция',
      gb: '🇬🇧 Великобритания',
      ae: '🇦🇪 Арабские Эмираты',
      tr: '🇹🇷 Турция'
    },
    confirm: {
      change: 'Уверены, что хотите сменить страну?',
    },
    notify: {
      successChanged: 'Страна успешно изменена',
    },
  },
  payment: {
    title: 'Оплата',
    paymentMethod: 'Метод оплаты',
    selectPaymentMethod: 'Выберите метод оплаты',
    pay: 'Оплатить',
    disclaimer:
      'Валюта списания может отличаться, но общая фактическая сумма от этого не меняется. Чтобы завершить платеж, нажмите на кнопку "Оплатить"',
  },
  tariff: {
    name: {
      free: 'Бесплатный',
      freePremium: 'Бесплатная премиум версия',
      premium: 'Премиум',
    },
    bandwidth: {
      bytes: 'Бит/c',
      kbytes: 'Кбит/c',
      mbytes: 'Мбит/с',
    },
    params: {
      remaining: 'Осталось',
      speed: 'Скорость',
      deviceCount: 'Кол-во устройств',
      discount: 'Скидка',
      monthly: 'Ежемесячно',
      free: 'Бесплатно',
      paidTo: 'Тариф оплачен до',
    },
    activateFor: 'Подключить Премиум за',
    renewFor: 'Продлить Премиум за',
    renew: 'Продлить Премиум',
    change: 'Сменить тариф',
    connectFree: 'Подключить бесплатно',
    popularChoice: 'Популярный выбор',
    beneficial: 'Выгодно!',
    availableList: 'Доступные планы',
    current: 'Выбранный тариф',
  },
  promoCode: {
    title: 'Промокод',
    enter: 'Введите промокод',
    enterPromoCodeToGetOrExtendPremium:
      'Получите или продлите Премиум тариф, введя промокод',
    activateButton: 'Активировать',
    yourPromoCode: 'Ваш промокод',
    confirmButton: 'Подтвердить',
    have: 'Есть промокод?',
    apply: 'Подтвердить',
    error:
      'Не верный промокод или он уже был активирован.Попробуйте ввести еще раз',
    success: 'Ура, ваш промокод активирован!',
  },
  device: {
    select: 'Выберите ваше устройство',
    selectDeviceToProtect:
      'Начните безопасный интернет-серфинг, выбрав устройство для защиты',
  },
  xray: {
    device: 'Устройство',
    deviceSlots: '{{used}} из {{limit}} устройств',
    devicePreparing: 'Подключение готовится',
    deviceDeleting: 'Удаление ещё не завершено',
    deviceReview: 'Нужна проверка подключения',

    remaining: 'Осталось: ',
    connection: 'Приложение X-Ray',
    duplicateConnection:
      'У тебя уже создан ключ-ссылка для  выбранной страны. Используй ключ выданный ранее!',
    createError: 'При создании подключения произошла ошибка',
    countryChangeHint:
      '⚠️ При смене страны текущее соединение перестанет работать. На Премиум тарифе ты можешь создать 3 подключения c разными странами выхода и использовать их одновременно на разных устройствах. Ты точно хочешь изменить страну выхода на текущем соединении?',
  },
  guide: {
    app: {
      title: 'Следуйте инструкциям',
      foxray: 'Скачать приложение FoXray',
      samsung: 'Ссылка на Samsung Store',
      microsoft: 'Ссылка на Microsoft Store',
      hiddifynext: 'Скачать приложение Hiddify-Next',
      linkKey: 'Ключ ссылка',
    },
    description: 'Используй видео инструкцию',
    stepByStep: 'Пошаговая инструкция:',
    mac: {
      app: {
        step: {
          1: {
            title: 'Установка приложения',
            description: {
              1: 'Скачайте приложение FoXray из App Store.',
              2: 'Установите приложение на MacOS.',
            },
          },
          2: {
            title: 'Запуск приложения',
            description: {
              1: 'Откройте установленное приложение.',
              2: 'При необходимости примите правила политики конфиденциальности.',
            },
          },
          3: {
            title: 'Вставляем ключ',
            description: {
              1: 'Скопируйте ключ-ссылку для настройки VPN:',
            }
          },
          4: {
            title: 'Установка VPN ключа',
            description: {
              1: 'Откройте установленное приложение FoXray.',
              2: 'В главном меню нажмите кнопку “Вставить ключ”.',
              3: 'При необходимости нажмите "Добавить из буфера обмена" и "Разрешить вставку".',
            },
          },
          5: {
            title: 'Запуск VPN',
            description: {
              1: 'Нажмите на кнопку “Запуск” для импортированного ключа.',
              2: 'При необходимости “Разрешите” добавление VPN конфигурации.\n\nПоздравляем, VPN запущен!\nБезопасного интернет-серфига с Private Gate.'
            }
          },
        },
      },
    },
    windows: {
      app: {
        step: {
          1: {
            title: 'Установка приложения',
            description: {
              1: 'Скачайте приложение Hiddify из Microsoft Store.',
              2: 'Установите приложение на Windows.',
            },
          },
          2: {
            title: 'Запуск приложения',
            description: {
              1: 'Откройте установленное приложение.',
              2: 'При необходимости примите правила политики конфиденциальности.',
            },
          },
          3: {
            title: 'Вставляем ключ',
            description: {
              1: 'Скопируйте ключ-ссылку для настройки VPN:',
            }
          },
          4: {
            title: 'Установка VPN ключа',
            description: {
              1: 'Откройте установленное приложение Hiddify.',
              2: 'В главном меню нажмите кнопку “Вставить ключ”.',
              3: 'При необходимости нажмите "Добавить из буфера обмена" и "Разрешить вставку".',
            },
          },
          5: {
            title: 'Запуск VPN',
            description: {
              1: 'Нажмите на кнопку “Запуск” для импортированного ключа.',
              2: 'При необходимости “Разрешите” добавление VPN конфигурации.\n\nПоздравляем, VPN запущен!\nБезопасного интернет-серфига с Private Gate.'
            }
          },
        },
      },
    },
    iphone: {
      app: {
        step: {
          1: {
            title: 'Установка приложения',
            description: {
              1: 'Переходим в App Store',
              2: 'Устанавливаем приложение Hiddify.',
            },
          },
          2: {
            title: 'Запуск приложения',
            description: {
              1: 'Откройте установленное приложение.',
              2: 'При необходимости примите правила политики конфиденциальности.'
            },
          },
          3: {
            title: 'Копирование VPN ключа',
            description: {
              1: 'Скопируйте ключ-ссылку для настройки VPN: ',
            },
          },
          4: {
            title: 'Установка VPN ключа',
            description: {
              1: 'Откройте установленное приложение.',
              2: 'В главном меню нажмите кнопку “Новый профиль”.',
              3: 'Нажмите на кнопку “Добавить из буфера обмена”.',
              4: 'При необходимости нажмите "Разрешить вставку".',
            },
          },
          5: {
            title: 'Запускаем VPN',
            description: {
              1: 'Нажмите на кнопку “Запуск” для импортированного ключа.',
              2: 'При необходимости “Разрешите” добавление VPN конфигурации.\n\nПоздравляем, VPN запущен!\nБезопасного интернет-серфинга с Private Gate!',
            },
          },
        },
      },
      
    },
    android: {
      app: {
        step: {
          1: {
            title: 'Установка приложения',
            description: {
              1: 'Скачайте приложение Hiddify из Google Play.',
              2: 'Установите приложение на Android.',
            },
          },
          2: {
            title: 'Запуск приложения',
            description: {
              1: 'Откройте установленное приложение.',
              2: 'При необходимости примите правила политики конфиденциальности.',
            },
          },
          3: {
            title: 'Копирование VPN ключа',
            description: {
              1: 'Скопируйте ключ-ссылку для настройки VPN: ',
            },
          },
          4: {
            title: 'Установка VPN ключа',
            description: {
              1: 'Откройте установленное приложение Hiddify.',
              2: 'В главном меню нажмите кнопку “Новый профиль”.',
              3: 'Нажмите на кнопку “Добавить из буфера обмена”.',
              4: 'При необходимости нажмите "Разрешить вставку".',
            },
          },
          5: {
            title: 'Даем разрешения',
            description: {
              1: 'Разрешаем запрос на подключение.',
              2: 'VPN ключ импортирован!',
            },
          },
          6: {
            title: 'Запуск VPN',
            description: {
              1: 'Нажмите на кнопку “Запуск” для импортированного ключа.',
              2: 'При необходимости “Разрешите” добавление VPN конфигурации.\n\nПоздравляем, VPN запущен!\nБезопасного интернет-серфинга с Private Gate.',
            },
          },
        },
      },
    },
    linux: {
      app: {
        step: {
          1: {
            title: 'Устанавливаем приложение',
            description: {
              1: 'Скачайте приложение Hiddify-Next.',
              2: 'Установите приложение на Linux.',
            }
          },
          2: {
            title: 'Открываем приложение',
            description: {
              1: 'Зайдите в свойства приложения правым щелчком мыши и сделайте его “Исполняемым как приложение”.',
              2: 'Откройте установленное приложение.',
              3: 'При необходимости примите правила политики конфиденциальности.',
            }
          },
          3: {
            title: 'Вставляем ключ',
            description: {
              1: 'Скопируйте ключ-ссылку для настройки VPN:',
            }
          },
          4: {
            title: 'Установка VPN ключа',
            description: {
              1: 'Откройте установленное приложение Hiddify.',
              2: 'В главном меню нажмите кнопку “Новый профиль”.',
              3: 'Нажмите на кнопку “Добавить из буфера обмена”.',
              4: 'При необходимости нажмите "Разрешить вставку".',
            }
          },
          5: {
            title: 'Запуск VPN',
            description: {
              1: 'Нажмите на кнопку “Запуск” для импортированного ключа.',
              2: 'При необходимости “Разрешите” добавление VPN конфигурации.\n\nПоздравляем, VPN запущен!\nБезопасного интернет-серфига с Private Gate.'
            }
          }
        }
      }
    },
    success: {
      mac: 'Для Mac (macOS)',
      windows: 'Для PC (Windows)',
      iphone: 'Для IPhone (IOS)',
      android: 'Для Android',
      linux: 'Для PC (GNU Linux)',
    },
    gift: {
      title: 'Ура, вам был активирован Премиум тариф на 7 дней!',
      subtitle: 'Это подарок от Private Gate VPN',
      description:
        'Дальше вы сможете пользоваться бесплатным тарифом с ограничением по скорости или вернуться к преимуществам Премиум подписки',
      thanks: 'Спасибо!',
    },
  },
  setup: {
    expanded: {
      language: 'Язык инструкций',
      client: 'Приложение',
      unavailable: 'Значение недоступно',
      show: 'Показать: {{label}}',
      hide: 'Скрыть: {{label}}',
      copy: 'Копировать: {{label}}',
      showValue: 'Показать',
      hideValue: 'Скрыть',
      copyValue: 'Копировать',
      copied: 'Скопировано',
      copyFailed: 'Не удалось скопировать. Выделите значение вручную.',
      openApp: 'Открыть в приложении',
      valuesError: 'Не удалось загрузить параметры подключения. Повторите попытку или напишите в поддержку.',
    },
    loading: 'Проверяем безопасную ссылку и загружаем инструкции…',
    expired: {
      title: 'Ссылка устарела',
      description: 'Ссылка устарела. Запросите новую ссылку через Private Gate Bot.',
      botAction: 'Открыть Private Gate Bot',
    },
    error: {
      title: 'Не удалось открыть настройку',
      description: 'Попробуйте ещё раз или напишите в поддержку.',
    },
    instructionsError: {
      title: 'Инструкции временно недоступны',
      description:
        'Не удалось загрузить актуальные инструкции. Повторите попытку позже или напишите в поддержку.',
    },
    ready: {
      title: 'Ваш VPN готов',
      description: 'Выберите устройство и следуйте инструкции',
    },
    platformSelector: 'Выбор устройства',
    recommendedApp: 'Рекомендуемое приложение: {{appName}}',
    version: 'Версия: {{version}}',
    downloadConfig: 'Скачать конфигурацию',
    retryAction: 'Повторить',
    supportAction: 'Написать в поддержку',
  },
  referralLink: {
    title: "Приведи друга!",
    description: `Ты знаешь, что за каждого приглашенного друга, ты получишь 7 дней Premium подписки в подарок?

Но это еще не все:
🎁 Каждый, кто перейдет по твоей ссылке, получит 7 дней Premium подписки в подарок
🎁 Если приглашенный оплатит подписку, то получит бонусом плюс 1 месяц, а ты получишь плюс 3 месяца Premium.(Акция действует один раз на каждого приглашенного).`,
    link: "Вот твоя реферальная ссылка для приглашения:",
    userActivations: "Всего пользователей приглашено:",
    userPaymentActivations: "Всего оплат приглашенными:",
    copyLink: "Скопировать ссылку",
    copySuccess: "Ссылка успешно скопирована"
  }
};
